import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { baseUrl } from "../utils/utils";

export const get_bank_list = createAsyncThunk("bank", async (data) => {
  const body = new FormData();
  body.append("action", "list");
  body.append("page", data.page);
  body.append("limit", data.rows);
  const response = await fetch(baseUrl + "bank.php", {
    method: "POST",
    body: body,
  });
  const res = await response.json();
  return res;
});

export const update_bank_status = createAsyncThunk(
  "banks/updateBankStatus",
  async (id, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      formData.append("action", "update_default_status");
      formData.append("id", id);

      const response = await fetch(baseUrl + "bank.php", {
        method: "POST",
        body: formData,
      });

      const data = await response.json();

      if (!response.ok || !data.success) {
        return rejectWithValue(data.message || "Failed to update status");
      }

      return data;
    } catch (error) {
      return rejectWithValue("Something went wrong");
    }
  }
);

export const check_cash_account = createAsyncThunk(
  "banks/checkCashAccount",
  async (_, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      formData.append("action", "check_cash_account");

      const response = await fetch(baseUrl + "bank.php", {
        method: "POST",
        body: formData,
      });

      const data = await response.json();

      if (!response.ok) {
        return rejectWithValue(data.message || "Failed to check cash account");
      }

      return data;
    } catch (error) {
      return rejectWithValue("Failed to check cash account");
    }
  }
);

const initialState = {
  bank_list: [],
  total_bank_count: 0,
  loading: false,
  update_status_loading: false,
  hasCashInSystem: false, // Added this new state
  checkingCashAccount: false, // Added loading state for cash check
};

const bankSlice = createSlice({
  name: "banks",
  initialState,

  extraReducers: (builder) => {
    builder
      .addCase(get_bank_list.pending, (state) => {
        state.loading = true;
      })
      .addCase(get_bank_list.rejected, (state) => {
        state.loading = false;
      })
      .addCase(get_bank_list.fulfilled, (state, action) => {
        state.loading = false;
        const data = action.payload;
        if (data.success) {
          state.bank_list = data.data;
          state.total_bank_count = parseInt(data.totalcount) || 0;

          // Also check if current page has cash account
          const hasCash = data.data.some(bank =>
            bank.ac_type?.toLowerCase() === 'cash'
          );
          if (hasCash) {
            state.hasCashInSystem = true;
          }
        } else {
          state.bank_list = [];
          state.total_bank_count = 0;
        }
      })
      .addCase(update_bank_status.pending, (state) => {
        state.update_status_loading = true;
      })
      .addCase(update_bank_status.fulfilled, (state) => {
        state.update_status_loading = false;
      })
      .addCase(update_bank_status.rejected, (state) => {
        state.update_status_loading = false;
      })
      .addCase(check_cash_account.pending, (state) => {
        state.checkingCashAccount = true;
      })
      .addCase(check_cash_account.fulfilled, (state, action) => {
        state.checkingCashAccount = false;
        state.hasCashInSystem = action.payload?.hasCash || false;
      })
      .addCase(check_cash_account.rejected, (state) => {
        state.checkingCashAccount = false;
      });
  },
});

export default bankSlice.reducer;